import React from 'react'

const CustomStyles: React.FC = () => {
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
  .-scale-100{transform:scale(-1)}
  .hyphens-auto{hyphens:auto}
  @media (min-width:768px) { /* sm */
    .sm\\:uif-max-w-718{max-width:44.875rem}
  }
  @media (min-width:992px) { /* md */
    .md\\:uif-max-w-942{max-width:58.875rem}
  }
  @media (min-width:1200px) { /* lg */
    .lg\\:uif-max-w-1160{max-width:72.5rem}
  }
  `,
      }}
    />
  )
}

export default CustomStyles
